import React, { Component } from "react";
import axios from "axios";
import { END_POINT } from "./endPoint";

export const MaintenanceContext = React.createContext();
export default class MaintenanceProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maintenanceList:
        JSON.parse(localStorage.getItem("maintenanceList")) || [],
    };
  }

  getMaintenance = async (data) => {
    await axios
      .post(`${END_POINT}/get/maintenance`, data)
      .then((res) => {
        console.log("ssss",res.data.data);
        if (res.data.status.code === 0) {
          localStorage.setItem(
            "maintenanceList",
            JSON.stringify(res.data.data)
          );
          this.setState({
            maintenanceList: res.data.data.filter(item => item.isDelete === 0)
          }); 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  addMaintenanceWithImage = async (data) => {
    let result = [{ code: -1, description: "" }];
    await axios
      .post(`${END_POINT}/add/maintenance_with_image`, data)
      .then((res) => {
        console.log(res.data);
        result.code = res.data.status.code;
        result.description = res.data.status.description;
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  };

  updateMaintenanceWithImage = async (data) => {
    let result = [{ code: -1, description: "" }];
    await axios
      .post(`${END_POINT}/update/maintenance_with_image`, data)
      .then((res) => {
        console.log(res.data);
        result.code = res.data.status.code;
        result.description = res.data.status.description;
      })
      .catch((error) => {
        console.log(error);
      });

    return result;
  };

  deleteMaintenance = async (data) => {
    let result = null;
    console.log("Maintenancecontext",data);
    await axios
      .post(`${END_POINT}/delete/maintenance`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  };

  render() {
    const dataMaintenance = {
      maintenanceList: this.state.maintenanceList,

      getMaintenance: this.getMaintenance,
      addMaintenanceWithImage: this.addMaintenanceWithImage,
      updateMaintenanceWithImage: this.updateMaintenanceWithImage,
      deleteMaintenance: this.deleteMaintenance,
    };

    return (
      <MaintenanceContext.Provider value={dataMaintenance}>
        {this.props.children}
      </MaintenanceContext.Provider>
    );
  }
}

// MaintenanceProvider.contextType = UserContext;
